import { graphql, useStaticQuery } from "gatsby";

const articleTransformer = (titles) => {
  const defaultQuery = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        filter: {
          fileAbsolutePath: {
            glob: "**/src/templates/life-done-better/articles/*.md"
          }
        }
      ) {
        edges {
          node {
            html
            frontmatter {
              title
              path
              thumbnail
            }
          }
        }
      }
    }
  `);

  const filteredData = defaultQuery.allMarkdownRemark.edges.filter((edge) =>
    titles.includes(edge.node.frontmatter.title)
  );

  const transformData = (data, heading = "Recommended Reads", imagePath = "/life-done-better/images/") => {
    return {
      title: {
        nodeType: "document",
        data: {},
        content: [
          {
            nodeType: "heading-3",
            data: {},
            content: [
              {
                nodeType: "text",
                value: heading,
                marks: [],
                data: {},
              },
            ],
          },
          {
            nodeType: "paragraph",
            data: {},
            content: [
              {
                nodeType: "text",
                value: "",
                marks: [],
                data: {},
              },
            ],
          },
        ],
      },
      cards: data.map((item) => ({
        image: {
          file: {
            url: `${imagePath}${item.node.frontmatter.thumbnail}`,
          },
        },
        title: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: item.node.frontmatter.title,
                  nodeType: "text",
                },
              ],
              nodeType: "paragraph",
            },
          ],
          nodeType: "document",
        },
        tileUrl: item.node.frontmatter.path,
      })),
    };
  };

  return transformData(filteredData);
};

export default articleTransformer;
